import {Injectable} from '@angular/core';
import {CrudService} from '@ngx-ivengi/crud';
import {Warranty} from './warranty.model';

@Injectable()
export class WarrantyService extends CrudService<Warranty> {
  public entityType = Warranty;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/warranty/warranty.service.ts